import React from "react";

const Header = () => {
  return (
    <div className="header">
      <h1>Lyrics Bites</h1>
      <h3>Learn your favourite song one bite at a time</h3>
    </div>
  );
};

export default Header;